import { url } from '@/conf/conf.js';
import { middleware } from "@/services/api/Middleware.js";

export async function activateRegister(data) {
    let options =  {
        method: "POST",
        headers: {
            Accept: "application/json",
            'Content-Type': "application/json",
        },
        body: JSON.stringify({
            id: data.id,
            method: "activate",
        }),
    };
    return middleware(url, options, [])()
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
        console.error('Error:', error);
    });
}